exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BannerContainer_2lPpFFNC {\n    width: 1000px;\n    margin: 0 auto;\n}\n\n.focus_3zl_r6JK {\n    width: 1000px;\n    height: 472px;\n    position: relative;\n    margin-top: 18px;\n    overflow: hidden;\n}\n\n.focus_3zl_r6JK .textBg_KdZip9mm {\n    width: 1000px;\n    height: 90px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    background: #000;\n    filter: alpha(opacity=50);\n    opacity: 0.5;\n}\n\n.focus_3zl_r6JK .text_1YHvZZN8 {\n    width: 980px;\n    height: 54px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    color: #fff;\n    padding: 18px 0 18px 20px;\n}\n\n.focus_3zl_r6JK h1 {\n    font-size: 22px;\n    line-height: 30px;\n}\n\n.focus_3zl_r6JK p {\n    font-size: 16px;\n    line-height: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"BannerContainer": "BannerContainer_2lPpFFNC",
	"focus": "focus_3zl_r6JK",
	"textBg": "textBg_KdZip9mm",
	"text": "text_1YHvZZN8"
};